var ApiConsumerUsage = Backbone.Model.extend({
    idAttribute: 'key',
    url: function() {
        return Core.contextRoot + '/apiconsumer/' + this.id + '/usage';
    },

    isExpired: function() {
        return this.get('expires') && new Date().getTime() > this.get('expires');
    },
});

var ApiConsumerUsages = Backbone.Collection.extend({
    model: ApiConsumerUsage,
    url: function() {
        return Core.contextRoot + '/apiconsumer/all/usage'
    },
});
